import { yup } from '@jbc-year-end-adj/common/yup';

export type Schema = {
  comment?: string;
};

export const schema = yup.object({
  comment: yup
    .string()
    .max(1000, 'コメントは1000文字までで入力してください')
    .nullable()
});
